import { render, staticRenderFns } from "./MenuCreate.vue?vue&type=template&id=406bd006&"
import script from "./MenuCreate.vue?vue&type=script&lang=ts&"
export * from "./MenuCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports